import Configuration from '../configuration';
import { $httpProvider } from '../providers';

import mapKeys from 'lodash/mapKeys';
import camelCase from 'lodash/camelCase';
import snakeCase from '../utils/snake-case.util';
import deeply from '../utils/deeply.util';

function postReclamation(demande) {
  return $httpProvider()({
    method: 'POST',
    url: Configuration.postLte,
    data: deeply(mapKeys)(demande, (value, key) => snakeCase(key))
  }).then(r => deeply(mapKeys)(r.data, (value, key) => camelCase(key)));
}

export default {
  postReclamation
};



// WEBPACK FOOTER //
// ./src/repositories/reclamation-lte.repository.js